
import React from "react";
import { Create } from "adminApi/VehicleListApi/VehicleList";
import { validateForm } from "utils/validation";
import { VehicleListRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddVehicleTypeForm from "./components/AddVehicleTypeForm";
import fields from "../json/VehicleTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddVehicleType = ({ setRefetch, refetch }) => {
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        VehicleListRules
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, VehicleListRules);
            setErrors(err);
            return err;
        },
        () => {
            setRefetch(!refetch);
            setValues(initialValues);
        },
        "Vehicle type created successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddVehicleTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Vehicle Type"
            />
        </>
    );
};

export default AddVehicleType;
